module.exports = __webpack_public_path__ + "img/_1.69ac42de.png";